class RatioBar {
  public achieved: any;
  public unachieved: any;
}

export default RatioBar;